import {React, useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { notification } from 'antd';

import SAISVG from "../../../../../_template/helpers/CommonFunction";
import ButtonLoader from "../../../../component/common/ButtonLoader";
import ValidationMessage from "../../../../component/common/ValidationMessage";
import customStyle from '../../../../../cssModule/custom.module.css';
import { ValidateEmail } from '../../../../component/common/Helper';

const AddSystemAdminForm = (props) => {
    const { updateData, totalRecords } = props;
    const [api, contextHolder] = notification.useNotification();
    const { totalSysAdminCount, sysAdminUpdateData } = props;

    const inputRef = useRef(null);

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    const [isVisible, setIsVisible] = useState(false);
    const [businessData, setBusinessData] = useState([]);
    const [sysAdminFormData, setSysAdminFormData] = useState({
        full_name : "", 
        email : "" ,
        assign_business : [],
        user_name : "",
        password : "",
        sys_admin_update_id : "",
        sys_admin_old_user_name : "",
        sass_id: localStorage.getItem('sass_id'),
        type: loginUserType,
        login_user_name: loginUserType == 'SA' ? localStorage.getItem('system_username') : ''
    });
    const [addSysAdminFormError, setAddSysAdminFormError] = useState({});
    const [isShowButtonLoader, setIsShowButtonLoader] = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);

    useEffect(()=>{
        getAllBusiness()
    }, [])

    const getAllBusiness = async() => {
        try {
            const api_params = {};
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                }
            };

            await axios.post(`${api_base_url}admin/get-all-business`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        var resBusinessList = res.data.data;
                        const formattedBusiness = resBusinessList.map(business => ({
                            value: business.sass_id,
                            label: business.business_name
                        }));
                        setBusinessData(formattedBusiness)
                    }
                })
                .catch((error) => {
                    console.error(error);
                }) 
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
            // setLoaderStatus(false);
        }
    }

    const inputChangeHandler = (selectedOption, actionMeta) => {
        if (actionMeta?.name) {
            const { name } = actionMeta;
            const fieldError = validateField(name, selectedOption);
            setAddSysAdminFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));

            // if(actionMeta.name === 'channel_type'){
            //     setSysAdminFormData((prevData) => ({
            //         ...prevData,
            //         [name]: [selectedOption],
            //     }));
            // }
            // else{
                setSysAdminFormData((prevData) => ({
                    ...prevData,
                    [name]: selectedOption,
                }));
            //}
        }
        else if (selectedOption?.target) {
            const { name, type, value, checked } = selectedOption.target;
            const inputValue = type === "checkbox" ? (checked ? "Y" : "N") : value;
            const fieldError = validateField(name, inputValue);
            setAddSysAdminFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setSysAdminFormData((prevData) => ({
                ...prevData,
                [name]: inputValue,
            }));
        }
    };

    const togglePasswordVisibility = () => {
        setPasswordShown(!passwordShown)
    }

    const validateField = (name, value) => {
        let error = "";
        if (name === "full_name") {
            if (!value) {
                error = "Full name is required";
            } 
        }
        if(name === 'email'){
            if (!value) {
                error = "Email is required";
            }
            else if (!ValidateEmail(value)) {
                error = "Invalid email address";
            }
        }
        if(name === 'assign_business'){
            if (!value || (Array.isArray(value) && value.length === 0)) {
                error = "Please select at least one Business.";
            }
        }
        if(name === 'user_name'){
            if (!value) {
                error = "User name is required";
            }
        }
        if(name === 'password'){
            if (!value) {
                error = "Password is required";
            }
        }
        return error;
    };
    
    const formCloseHandler = (e) => {
        setIsVisible(false);
        setSysAdminFormData({
            full_name : "", 
            email : "" ,
            assign_business : [],
            user_name : "",
            password : "",
            sys_admin_update_id : "",
            sys_admin_old_user_name : "",
            sass_id: '',
            type: '',
            login_user_name: ''
        });
    }
    const AddSysAdminHandler = (e) => {
        setIsVisible(true);
    }

    const formSubmitHandler = async (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in sysAdminFormData) {
            newErrors[key] = validateField(key, sysAdminFormData[key]);
        }
        setAddSysAdminFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            let apiToken = '';
            if(loginUserType === 'A') {
                apiToken = localStorage.getItem('token')
            } else if(loginUserType === 'SA') {
                apiToken = localStorage.getItem('systemAdminToken')
            }

            setIsShowButtonLoader(true)
            const api_headers = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : apiToken
                }
            };
            await axios.post(`${api_base_url}admin/add-system-admin`, sysAdminFormData, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    setSysAdminFormData({
                        full_name : "", 
                        email : "" ,
                        assign_business : [],
                        user_name : "",
                        password : "",
                        sys_admin_update_id : "",
                        sys_admin_old_user_name : ""
                    });
                    setAddSysAdminFormError({});
                    api["success"]({
                        message: 'Success',
                        description: res.data.message
                    });
                    setIsVisible(false);
                    
                    if(updateData) {
                        props.recordUpdated(res.data.data[0]);
                    } else {
                        props.recordInserted(res.data.data[0]);
                    }
                } else if(res.data.status === 'error') {
                    api["error"]({
                        message: 'Error',
                        description: res.data.message
                    });
                }
            })
            .catch((error) => {
                console.error(error);
            }) 
            setIsShowButtonLoader(false)
        } 
    }

    useEffect(()=>{
        if(Object.keys(updateData).length > 0){
            const assignedIds = updateData.assigned_business.map(item => item.id);

            const updateAssignBusiness = businessData.filter(item =>assignedIds.includes(item.value));
            setSysAdminFormData({
                full_name : updateData.name, 
                email : updateData.email ,
                assign_business : updateAssignBusiness,
                user_name : updateData.username,
                password : atob(updateData.password),
                sys_admin_update_id: updateData.system_admin_id,
                sys_admin_old_user_name: updateData.username
            });
            setAddSysAdminFormError({});
            setIsVisible(true);
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }
    },[updateData])

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <div className="card card-flush border" id="sys_admin_add_card">
                        <div className="card-header py-3">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800 fs-2">
                                    System User
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total {totalRecords} system user are available
                                </span>
                            </h3>
                            {!isVisible ? 
                                <div className="card-toolbar">
                                    <div className="d-flex flex-stack flex-wrap gap-4">
                                        <div className="position-relative my-1 m-w-100">
                                            <SAISVG path="media/icons/duotune/general/gen004.svg" className="svg-icon-muted svg-icon-2 position-absolute top-50 translate-middle-y ms-4" />
                                            <input 
                                                type="text" 
                                                className="form-control form-control-solid ps-12 search-user border" placeholder="Search" 
                                                onChange={props.sysAdminSearchInput}
                                            />
                                        </div>
                                        <div className="d-flex align-items-center fw-bold">
                                            <a 
                                                className="btn btn-dark px-6 add-new-user"
                                                onClick={AddSysAdminHandler}
                                            >
                                                Add System User
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            :''}
                        </div>
                        
                        {isVisible ? 
                            <div className={`card-body pt-0 ${customStyle.contentBody} ${isVisible ? customStyle.slideDown : customStyle.slideUp}`}>
                                <form onSubmit={formSubmitHandler}>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Full Name
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addSysAdminFormError.full_name ? 'is-invalid' : ''}`}
                                                    placeholder="Enter full name"
                                                    name='full_name'
                                                    onChange={inputChangeHandler}
                                                    value={sysAdminFormData.full_name}
                                                    autoFocus={true}
                                                    ref={inputRef}
                                                />
                                                {addSysAdminFormError.full_name && <ValidationMessage className='text-danger' message ={addSysAdminFormError.full_name}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Email
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addSysAdminFormError.email ? 'is-invalid': ''}`}
                                                    placeholder="Enter email"
                                                    name='email'
                                                    onChange={inputChangeHandler}
                                                    value={sysAdminFormData.email}
                                                />
                                                {addSysAdminFormError.email && <ValidationMessage className='text-danger' message ={addSysAdminFormError.email}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Select Business
                                                </label>
                                                <Select
                                                    className='react-select-styled react-select-solid' 
                                                    classNamePrefix='react-select' 
                                                    options={businessData} 
                                                    placeholder='Select Business' 
                                                    name='assign_business'
                                                    isClearable
                                                    isMulti
                                                    onChange={inputChangeHandler}
                                                    value={sysAdminFormData.assign_business}
                                                />
                                                {addSysAdminFormError.assign_business && <ValidationMessage className='text-danger' message ={addSysAdminFormError.assign_business}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Username
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-solid ${addSysAdminFormError.user_name ? 'is-invalid' : ''}`}
                                                    placeholder="Enter username"
                                                    name='user_name'
                                                    onChange={inputChangeHandler}
                                                    value={sysAdminFormData.user_name}
                                                    readOnly={sysAdminFormData.sys_admin_update_id}
                                                />
                                                {addSysAdminFormError.user_name && <ValidationMessage className='text-danger' message ={addSysAdminFormError.user_name}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="mb-10">
                                                <label className="form-label required">
                                                    Password
                                                </label>
                                                <div className="input-group input-group-solid">
                                                    <input 
                                                        type="text" 
                                                        className={`form-control ${!passwordShown ? 'inp-secure' : ''} ${addSysAdminFormError.password ? 'is-invalid' : ''}`}
                                                        placeholder="Enter password"
                                                        name='password'
                                                        onChange={inputChangeHandler}
                                                        value={sysAdminFormData.password}
                                                    />
                                                    <span className="input-group-text">
                                                        { !passwordShown && 
                                                            <FontAwesomeIcon 
                                                                icon={faEye} 
                                                                className='fs-4 cursor-pointer'
                                                                onClick={ togglePasswordVisibility }
                                                            />
                                                        }
                                                        { passwordShown && 
                                                            <FontAwesomeIcon 
                                                                icon={faEyeSlash} 
                                                                className='fs-4 cursor-pointer'
                                                                onClick={ togglePasswordVisibility }
                                                            />
                                                        }
                                                    </span>
                                                </div>
                                                {addSysAdminFormError.password && <ValidationMessage className='text-danger' message ={addSysAdminFormError.password}/>}
                                            </div>
                                        </div>
                                        <div className="col-md-12 text-end">
                                            <button 
                                                className="btn btn-light me-4 border" 
                                                onClick={(e) => { e.preventDefault(); formCloseHandler()}}
                                            >
                                                Close
                                            </button>
                                            <button 
                                                className={`btn btn-dark ${isShowButtonLoader && 'disabled'}`} 
                                                type="submit"
                                            >
                                                {
                                                    isShowButtonLoader ? <ButtonLoader btnHtml='Please wait...' className='me-2'/> : 'Save'
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        :''}
                    </div>
                </div>
            </div>
            {contextHolder}
        </>
    )
}

export default AddSystemAdminForm;